// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_c7-2";
export var aiChatCartContainerExit = "_c7-4";
export var aiChatContainerLarge = "_c7-0";
export var aiChatContainerSmall = "_c7-1";
export var aiChatIcon = "_c7-6";
export var slideInFromRight = "_c7-3";
export var slideOutToRight = "_c7-5";